import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const visibilityPermissionsContainerCss = (
  isContentSettingsToggleEnabled: boolean,
) => ({
  backgroundColor: isContentSettingsToggleEnabled ? ui.core[200] : "inherit",
  padding: "16px",
  width: "100%",
});
